import React from "react";
import { Grid, Autocomplete, TextField } from "@mui/material";
import { OPTION_PUTS_CALLS } from "../orderDialogHelpers";

/**
 * Options fields when asset type is Options (investment type 10).
 * `onFieldChange(field, value)` or `setFormData` updater for strike/expiration.
 */
const OrderOptionFieldsSection = ({
  formData,
  onFieldChange,
  setFormData,
  inputLabelProps,
  gridSize = { xs: 12 },
}) => {
  const setField = (field, value) => {
    if (onFieldChange) {
      onFieldChange(field, value);
      return;
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const labelProps = inputLabelProps ?? { shrink: true, sx: { fontWeight: 600 } };

  return (
    <>
      <Grid size={gridSize}>
        <Autocomplete
          options={OPTION_PUTS_CALLS}
          getOptionLabel={(option) => option.label}
          value={
            formData.option === 0
              ? { label: "Calls", value: 0 }
              : { label: "Puts", value: 1 }
          }
          onChange={(event, newValue) =>
            setField("option", newValue?.value ?? 1)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Options"
              variant="outlined"
              size="small"
              InputLabelProps={labelProps}
              required
            />
          )}
          disableClearable
        />
      </Grid>
      <Grid size={gridSize}>
        <TextField
          fullWidth
          label="Strike Price"
          type="number"
          value={formData.strikePrice}
          onChange={(e) => setField("strikePrice", e.target.value)}
          variant="outlined"
          size="small"
          InputLabelProps={labelProps}
          required
        />
      </Grid>
      <Grid size={gridSize}>
        <TextField
          fullWidth
          label="Expiration Date"
          type="date"
          value={formData.expirationDate}
          onChange={(e) => setField("expirationDate", e.target.value)}
          variant="outlined"
          size="small"
          InputLabelProps={labelProps}
          required
        />
      </Grid>
    </>
  );
};

export default OrderOptionFieldsSection;
